export default __webpack_public_path__ + "static/media/transfacil_galery_8.333e78d7.jpg";